import React from 'react';

// Define keyframes animations in a style tag
const StyleTag = () => (
  <style jsx global>{`
    /* Keyframes for entrance animations */

    @keyframes pulse-glow {
      0%,
      100% {
        box-shadow: 0 0 0 2px rgba(228, 177, 122, 0.1);
      }
      50% {
        box-shadow: 0 0 0 4px rgba(228, 177, 122, 0.2);
      }
    }

    @keyframes slide-in {
      0% {
        transform: translateX(-10px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes solutionFadeIn {
      0% {
        opacity: 0;
        transform: translateY(10px);
      }
      100% {
        opacity: 1;
        transform: translateY(0px);
      }
    }

    .scale-dot {
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .scale-dot.active {
      animation: pulse-glow 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }

    .scale-fill {
      transition: width 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .score-display {
      animation: slide-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }

    .hide-number-spinners {
      -moz-appearance: textfield;
    }

    .hide-number-spinners::-webkit-outer-spin-button,
    .hide-number-spinners::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .animate-solution-fade-in {
      animation: solutionFadeIn 0.3s ease-out forwards;
    }

    .spinner {
      animation: spin 1s linear infinite;
    }

    /* AI Learning Prompt Styles */
    .ai-learning-modal {
      border-radius: 1rem;
      border: 1px solid rgba(228, 177, 122, 0.12);
      background: linear-gradient(135deg, #fdf8f3 0%, #f9ede2 100%);
      box-shadow: rgba(228, 177, 122, 0.06) 0px 2px 4px -2px, rgba(228, 177, 122, 0.04) 0px 4px 8px -2px;
      backdrop-filter: blur(12px) saturate(180%);
      -webkit-backdrop-filter: blur(12px) saturate(180%);
    }

    .ai-learning-header {
      padding: 1rem;
      border-bottom: 1px solid rgba(228, 177, 122, 0.1);
      background: linear-gradient(to right, rgba(228, 177, 122, 0.08), rgba(228, 177, 122, 0.04));
    }

    .ai-learning-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      background: linear-gradient(135deg, #e4b17a, #c99b69);
      color: white;
      box-shadow: 0 2px 8px rgba(228, 177, 122, 0.2);
    }

    .ai-learning-title {
      font-size: 1.125rem;
      font-weight: 600;
      color: #8c6b4a;
      letter-spacing: -0.01em;
      margin: 0;
    }

    .ai-learning-content {
      padding: 1rem;
    }

    .ai-learning-description {
      color: #a17c57;
      font-size: 0.9rem;
      line-height: 1.5;
      margin-bottom: 1rem;
    }

    .ai-learning-actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
    }

    .ai-learning-button {
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      font-size: 0.875rem;
      font-weight: 500;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      align-items: center;
      gap: 0.5rem;
      border: none;
      cursor: pointer;
    }

    .ai-learning-button:hover {
      transform: translateY(-1px);
    }

    .ai-learning-button.primary {
      background: linear-gradient(135deg, #e4b17a, #c99b69);
      color: white;
      box-shadow: 0 4px 12px rgba(228, 177, 122, 0.2);
    }

    .ai-learning-button.primary:hover {
      box-shadow: 0 8px 24px rgba(228, 177, 122, 0.3);
    }

    .ai-learning-button.secondary {
      background: white;
      color: #a17c57;
      border: 1px solid rgba(228, 177, 122, 0.2);
      box-shadow: 0 1px 2px rgba(228, 177, 122, 0.05);
    }

    .ai-learning-button.secondary:hover {
      background: rgba(228, 177, 122, 0.05);
    }

    .ai-learning-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    .ai-learning-button:disabled:hover {
      transform: none;
    }
  `}</style>
);

export default StyleTag;